export function HoleStyled(props = {}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="303"
      height="432"
      viewBox="0 0 360 512"
    >
      <defs>
        <pattern
          id="img1"
          patternUnits="userSpaceOnUse"
          width="360"
          height="512"
        >
          <image href={props.image} x="0" y="0" width="360" height="512" />
        </pattern>
      </defs>

      <path
        fill="url(#img1)"
        d="M33.6667 13.3333C33.2222 13.7778 34.2778 13.7222 34.3333 13.6667C34.7778 13.2222 33.7222 13.2778 33.6667 13.3333z"
      />
      <path
        fill="url(#img1)"
        d="M94 13C106.461 20.8412 125.402 21.1623 138 14C133.531 12.1248 127.809 13 123 13L94 13M146 14C148.523 14.9903 150.358 14.6169 153 14C150.413 12.9346 148.679 13.2185 146 14M207 13C209.314 14.5911 211.19 14.8575 214 15C211.692 13.2405 209.908 13.0828 207 13M222 13C233.627 24.6484 252.526 17.1171 266 14C261.531 12.1248 255.809 13 251 13L222 13z"
      />
      <path fill="url(#img1)" d="M294 13L295 14L294 13z" />
      <path
        fill="url(#img1)"
        d="M309 13C314.573 16.5072 330.713 22.1767 334 14C325.774 12.4728 317.339 13 309 13M33 14L33 16C34.6351 15.455 34.455 15.635 35 14L33 14M168 14C171.655 18.3097 176.3 20.8097 179 26C183.393 22.4612 188.367 18.2844 192 14C187.919 14.8208 184.028 19.2108 180 19.0038C175.91 18.7937 172.203 14.8132 168 14M295 14C297.622 18.3601 299.731 21.8236 300 27C304.632 25.0997 309.036 22.8547 314 22C308.934 18.2097 301.089 15.7408 295 14z"
      />
      <path
        fill="url(#img1)"
        d="M276.333 15.6667C276.278 15.7223 276.222 16.7778 276.667 16.3333C276.722 16.2778 276.778 15.2222 276.333 15.6667M83 16L84 17L83 16z"
      />
      <path
        fill="url(#img1)"
        d="M255 23C261.521 26.5444 269.254 28.0035 276 31.2585C279.18 32.7928 283.284 35.8437 286.985 35.4691C290.927 35.0702 293.401 30.5849 293.742 27C294.154 22.6752 286.408 12.7286 283.137 19.4005C281.116 23.5219 288.284 22.2993 290 22C287.93 28.0289 282.18 31.3166 277.742 24.8943C275.913 22.2465 276.028 19.0703 276 16C268.793 17.7079 262.235 21.3255 255 23M339 17C331.823 28.6629 336.178 40.803 339 53C340.58 49.2339 339.754 45.0127 340.464 41C342.101 31.7355 345.842 25.3078 339 17z"
      />
      <path
        fill="url(#img1)"
        d="M21 18L21 21C21.6961 19.4463 21.6961 19.5537 21 18z"
      />
      <path
        fill="url(#img1)"
        d="M99 31C101.164 37.126 99.8018 41.5976 93 43C98.4429 53.6392 99.3101 64.6784 89.8951 73.8148C86.9151 76.7066 82.688 77.9473 79.814 80.814C74.0515 86.562 69.8184 96.0305 60 91C54.0414 94.5758 51.6483 95.6712 46 91C35.0124 95.6473 31.8558 87.4681 25.186 80.814C23.0316 78.6647 19.6655 77.398 17 76C11.3418 90.998 13 107.256 13 123C13 131.015 11.8042 140.126 13.3789 148C14.3565 152.889 17.0261 157.346 18.7137 162C21.6653 170.14 23.967 179.374 24.8295 188C26.6036 205.743 19.7293 219.577 15 236C16.4336 237.393 17.0449 238.233 18 240C24.3824 237.068 28.7017 245.511 28 251C33.1043 253.989 33.1043 258.011 28 261C28.7017 266.489 24.3824 274.932 18 272C17.0449 273.767 16.4335 274.607 15 276C19.5828 291.914 25.7161 304.899 24.9606 322C24.2934 337.106 16.2481 349.652 13.3789 364C12.0494 370.648 13 378.238 13 385C13 395.93 12.3386 407.096 13.0895 418C14.7563 442.204 33.5902 463.275 29 488C33.7251 487.797 38.3576 486.875 43 486C40.7583 484.818 38.1565 484.007 36.6065 481.853C33.1486 477.046 37.6822 471.712 42.0039 469.569C47.8957 466.646 55.5809 466.476 62 467.174C76.9567 468.799 90.3489 479.295 105 482.764C108.474 483.586 112.408 484.732 116 484.505C123.91 484.003 129.814 481.242 138 483.015C149.983 485.609 159.233 498.93 170.957 489.468C172.561 488.173 173.909 486.675 175.084 484.985C176.805 482.511 177.964 479.807 179 477L181 477C182.058 479.851 183.283 482.488 185.055 484.985C188.153 489.352 194.137 494.566 200 493.474C204.14 492.703 207.4 488.889 211 486.905C216.327 483.969 222.923 482.239 229 482.043C234.277 481.873 238.868 484.179 244 484.505C252.223 485.026 261.532 480.978 269 478C271.669 476.935 275.304 476.077 277.397 474.006C280.033 471.398 278.845 466.34 279.09 463C279.449 458.117 281.058 453.342 283.274 449C290.304 435.226 306.605 426.689 322 429.465C329.841 430.878 336.178 435.217 343 439C343.818 432.565 345.922 426.426 346.714 420C347.919 410.219 347 399.849 347 390C347 381.864 347.952 373.058 346.79 365C345.906 358.87 342.524 352.806 340.435 347C337.664 339.297 335.402 330.197 335.039 322C334.581 311.635 335.956 301.907 339.025 292C341.175 285.063 345.478 279.268 343 272C336.618 274.932 332.298 266.489 333 261C327.896 258.011 327.896 253.989 333 251C332.298 245.511 336.618 237.068 343 240C345.319 233.197 341.793 228.44 339.671 222C337 213.893 335.014 205.557 335 197C334.983 186.238 336.794 175.252 340.189 165C342.075 159.305 345.441 153.904 346.621 148C348.012 141.045 347 133.075 347 126C347 114.75 347.732 103.22 346.91 92C345.18 68.3963 326.471 48.3955 331 24C326.275 24.2029 321.642 25.1253 317 26C319.242 27.1818 321.844 27.9927 323.394 30.1474C326.851 34.9542 322.318 40.2878 317.996 42.4313C312.099 45.3562 304.424 45.5166 298 44.8264C282.959 43.2103 269.717 32.7205 255 29.2361C251.526 28.4137 247.592 27.2676 244 27.4954C236.09 27.9969 230.186 30.7577 222 28.9854C210.161 26.4222 200.626 12.9745 189.093 22.5324C187.527 23.8301 186.228 25.3605 185.055 27.0146C183.283 29.5118 182.058 32.1493 181 35L179 35C177.964 32.1931 176.805 29.489 175.084 27.0146C172.043 22.6425 165.792 17.4473 160 18.5262C156.193 19.2355 153.223 22.593 150 24.5216C145.206 27.3899 139.517 28.994 134 29.7106C127.503 30.5545 122.262 27.8924 116 27.4954C110.462 27.1443 104.216 29.3432 99 31z"
      />
      <path
        fill="url(#img1)"
        d="M326.667 18.3333C326.222 18.7777 327.278 18.7222 327.333 18.6667C327.778 18.2222 326.722 18.2779 326.667 18.3333z"
      />
      <path
        fill="url(#img1)"
        d="M22.3333 19.6667C22.2779 19.7221 22.2222 20.7778 22.6667 20.3333C22.7223 20.2777 22.7778 19.2222 22.3333 19.6667M20.6667 21.3333C20.2222 21.7778 21.2778 21.7222 21.3333 21.6667C21.7777 21.2223 20.7222 21.2778 20.6667 21.3333z"
      />
      <path fill="url(#img1)" d="M84 21L85 22L84 21z" />
      <path
        fill="url(#img1)"
        d="M89 21L87 22C88.4531 22.5547 89.0757 22.6045 89 21z"
      />
      <path
        fill="url(#img1)"
        d="M137 21C138.248 21.6848 138.548 21.7488 140 22C138.752 21.3152 138.452 21.2512 137 21M220 21C221.248 21.6848 221.548 21.7488 223 22C221.752 21.3152 221.452 21.2512 220 21z"
      />
      <path
        fill="url(#img1)"
        d="M98 25L105 24C102.262 21.9691 98.8505 21.0309 98 25z"
      />
      <path fill="url(#img1)" d="M135 22L136 23L135 22M224 22L225 23L224 22z" />
      <path fill="url(#img1)" d="M18 23L19 24L18 23z" />
      <path
        fill="url(#img1)"
        d="M295 39C302.716 39.9752 314.125 41.5798 319 34C317.521 33.0143 317.797 33 316 33C315.014 34.4785 315 34.2032 315 36C311.949 33.3719 311.675 31.7823 313 28C306.46 29.7888 298.259 32.7121 295 39z"
      />
      <path
        fill="url(#img1)"
        d="M124.667 29.3333C124.222 29.7776 125.278 29.7223 125.333 29.6667C125.778 29.2222 124.722 29.2778 124.667 29.3333z"
      />
      <path
        fill="url(#img1)"
        d="M234.667 29.3333C234.222 29.778 235.278 29.7221 235.333 29.6667C235.778 29.2224 234.722 29.2777 234.667 29.3333M283.667 29.3333C283.222 29.7777 284.278 29.7223 284.333 29.6667C284.778 29.2222 283.722 29.2778 283.667 29.3333z"
      />
      <path
        fill="url(#img1)"
        d="M311 30L311 34C311.71 32.2404 311.71 31.7595 311 30z"
      />
      <path
        fill="url(#img1)"
        d="M346 38L346 66C348.604 59.7934 348.604 44.2066 346 38z"
      />
      <path
        fill="url(#img1)"
        d="M340 40L340 48C341.161 45.2301 341.161 42.7699 340 40M345 42L345 46C345.71 44.2404 345.71 43.7596 345 42z"
      />
      <path
        fill="url(#img1)"
        d="M345 46L345 55C346.256 52.0057 346.256 48.9942 345 46z"
      />
      <path
        fill="url(#img1)"
        d="M89.3333 58.6667C89.2777 58.7223 89.2223 59.7777 89.6667 59.3333C89.7221 59.2779 89.7778 58.2221 89.3333 58.6667z"
      />
      <path fill="url(#img1)" d="M88 62L89 63L88 62z" />
      <path
        fill="url(#img1)"
        d="M87 65L88 66L87 65M86 67L87 68L86 67M20 69C20.5451 70.6352 20.3648 70.455 22 71C21.455 69.3649 21.6351 69.545 20 69M35.6667 82.3333C35.2222 82.7778 36.2778 82.7222 36.3333 82.6667C36.7778 82.2222 35.7222 82.2778 35.6667 82.3333M70 82L71 83L70 82z"
      />
      <path
        fill="url(#img1)"
        d="M36 83C38.3144 84.5911 40.1901 84.8575 43 85C40.7168 83.7785 38.5721 83.3479 36 83M64 84C66.0442 84.7744 66.8447 84.5922 69 84C67.1535 83.5325 65.9314 83.6988 64 84z"
      />
      <path
        fill="url(#img1)"
        d="M36 92C38.6127 93.0977 41.1645 92.9928 44 93C41.3873 91.9023 38.8355 92.0072 36 92M61 92C63.0521 92.8742 64.7472 92.9528 67 93C64.9479 92.1258 63.2528 92.0472 61 92z"
      />
      <path
        fill="url(#img1)"
        d="M18.3333 160.667C18.2779 160.722 18.2222 161.778 18.6667 161.333C18.7223 161.278 18.7777 160.222 18.3333 160.667M341.333 160.667C341.278 160.722 341.222 161.778 341.667 161.333C341.722 161.278 341.778 160.222 341.333 160.667M339.333 166.667C339.278 166.722 339.222 167.778 339.667 167.333C339.722 167.278 339.778 166.222 339.333 166.667M15 168L16 169L15 168M344 168L345 169L344 168z"
      />
      <path
        fill="url(#img1)"
        d="M16.3333 171.667C16.2778 171.722 16.2222 172.778 16.6667 172.333C16.7223 172.278 16.7777 171.222 16.3333 171.667M343.333 171.667C343.278 171.722 343.222 172.778 343.667 172.333C343.722 172.278 343.778 171.222 343.333 171.667M17 175L17 179C17.7102 177.241 17.7102 176.759 17 175M342 175L342 179C342.71 177.24 342.71 176.76 342 175z"
      />
      <path
        fill="url(#img1)"
        d="M18.3333 180.667C18.2778 180.722 18.2222 181.778 18.6667 181.333C18.7223 181.278 18.7777 180.222 18.3333 180.667M341.333 180.667C341.278 180.722 341.222 181.778 341.667 181.333C341.722 181.278 341.778 180.222 341.333 180.667z"
      />
      <path
        fill="url(#img1)"
        d="M18 182L18 186C18.7102 184.241 18.7102 183.759 18 182M341 182L341 186C341.71 184.24 341.71 183.759 341 182z"
      />
      <path
        fill="url(#img1)"
        d="M13 184L13 209C15.9752 202.103 15.9244 190.905 13 184M346 184L346 209C348.413 203.25 348.413 189.75 346 184z"
      />
      <path
        fill="url(#img1)"
        d="M24 185L24 188C24.6961 186.446 24.6961 186.554 24 185M335 185L335 188C335.696 186.446 335.696 186.554 335 185z"
      />
      <path
        fill="url(#img1)"
        d="M19 189L19 200C20.4309 196.59 20.4309 192.41 19 189M340 189L340 200C341.431 196.59 341.431 192.41 340 189z"
      />
      <path
        fill="url(#img1)"
        d="M19 200L19 203C19.6961 201.446 19.6961 201.554 19 200M340 200L340 203C340.696 201.446 340.696 201.554 340 200z"
      />
      <path
        fill="url(#img1)"
        d="M18 204L16 219C18.5899 214.76 19.9625 208.687 18 204z"
      />
      <path
        fill="url(#img1)"
        d="M24.3333 204.667C24.2778 204.722 24.2222 205.778 24.6667 205.333C24.7223 205.278 24.7778 204.222 24.3333 204.667M335.333 204.667C335.278 204.722 335.222 205.778 335.667 205.333C335.722 205.278 335.778 204.222 335.333 204.667z"
      />
      <path
        fill="url(#img1)"
        d="M341 204C341.017 210.039 342.166 215.265 344 221C345.133 216.205 343.127 208.425 341 204z"
      />
      <path
        fill="url(#img1)"
        d="M15.3333 217.667C15.2777 217.722 15.2223 218.778 15.6667 218.333C15.7221 218.278 15.7779 217.222 15.3333 217.667M344.333 217.667C344.278 217.722 344.222 218.778 344.667 218.333C344.722 218.278 344.778 217.222 344.333 217.667z"
      />
      <path
        fill="url(#img1)"
        d="M15.3333 219.667C15.2777 219.722 15.2223 220.778 15.6667 220.333C15.7222 220.278 15.7778 219.222 15.3333 219.667z"
      />
      <path
        fill="url(#img1)"
        d="M14.6667 221.333C14.2223 221.778 15.2778 221.722 15.3333 221.667C15.7778 221.222 14.7222 221.278 14.6667 221.333M344.667 221.333C344.222 221.778 345.278 221.722 345.333 221.667C345.778 221.222 344.722 221.278 344.667 221.333z"
      />
      <path
        fill="url(#img1)"
        d="M14 222L13 228C14.3054 225.819 14.7355 224.433 14 222z"
      />
      <path
        fill="url(#img1)"
        d="M345 222L346 228C346.889 225.492 346.495 224.185 345 222M13 241L13 244C13.6961 242.446 13.6961 242.554 13 241M19 242L19 245C19.6961 243.446 19.6961 243.554 19 242z"
      />
      <path
        fill="url(#img1)"
        d="M20 242L20 245C20.6961 243.446 20.6961 243.554 20 242z"
      />
      <path
        fill="url(#img1)"
        d="M340 242L340 245C340.696 243.446 340.696 243.554 340 242z"
      />
      <path
        fill="url(#img1)"
        d="M341 242L341 245C341.696 243.446 341.696 243.554 341 242z"
      />
      <path
        fill="url(#img1)"
        d="M14.3333 244.667C14.2777 244.722 14.2222 245.778 14.6667 245.333C14.7222 245.278 14.7778 244.222 14.3333 244.667M346.333 244.667C346.278 244.722 346.222 245.778 346.667 245.333C346.722 245.278 346.778 244.222 346.333 244.667M24 247L25 248L24 247M336 247L337 248L336 247z"
      />
      <path fill="url(#img1)" d="M13 249L14 250L13 249z" />
      <path
        fill="url(#img1)"
        d="M23 249L24 250L23 249M337 249L338 250L337 249M17.3333 250.667C17.2778 250.722 17.2222 251.778 17.6667 251.333C17.7223 251.278 17.7778 250.222 17.3333 250.667M343.333 250.667C343.278 250.722 343.222 251.778 343.667 251.333C343.722 251.278 343.778 250.222 343.333 250.667z"
      />
      <path
        fill="url(#img1)"
        d="M25 255L25 257L27 257L27 255L25 255M334 255L334 257L336 257L336 255L334 255z"
      />
      <path
        fill="url(#img1)"
        d="M17.3333 260.667C17.2778 260.722 17.2222 261.778 17.6667 261.333C17.7222 261.278 17.7778 260.222 17.3333 260.667M343.333 260.667C343.278 260.722 343.222 261.778 343.667 261.333C343.722 261.278 343.778 260.222 343.333 260.667M13 262L14 263L13 262z"
      />
      <path
        fill="url(#img1)"
        d="M23 262L24 263L23 262M337 262L338 263L337 262z"
      />
      <path
        fill="url(#img1)"
        d="M24 264L25 265L24 264M336 264L337 265L336 264M14.3333 266.667C14.2778 266.722 14.2222 267.778 14.6667 267.333C14.7223 267.278 14.7778 266.222 14.3333 266.667M346.333 266.667C346.278 266.722 346.222 267.778 346.667 267.333C346.722 267.278 346.778 266.222 346.333 266.667z"
      />
      <path
        fill="url(#img1)"
        d="M19 267L19 270C19.6961 268.446 19.6961 268.554 19 267z"
      />
      <path
        fill="url(#img1)"
        d="M20 267L20 270C20.6961 268.446 20.6961 268.554 20 267z"
      />
      <path
        fill="url(#img1)"
        d="M340 267L340 270C340.696 268.446 340.696 268.554 340 267z"
      />
      <path
        fill="url(#img1)"
        d="M341 267L341 270C341.696 268.446 341.696 268.554 341 267M13 268L13 271C13.6961 269.446 13.6961 269.554 13 268z"
      />
      <path
        fill="url(#img1)"
        d="M13 284C13.2763 287.161 14.0415 289.979 15 293C15.9614 289.749 14.7727 286.821 13 284M346 284L344 293C346.078 290.207 347.191 287.359 346 284z"
      />
      <path
        fill="url(#img1)"
        d="M15.3333 293.667C15.2778 293.722 15.2222 294.778 15.6667 294.333C15.7223 294.278 15.7778 293.222 15.3333 293.667z"
      />
      <path
        fill="url(#img1)"
        d="M16 293L18 308C19.9624 303.313 18.5899 297.24 16 293M343 293C341.95 298.088 341.014 302.779 341 308C342.978 303.885 344.692 297.335 343 293z"
      />
      <path
        fill="url(#img1)"
        d="M344.333 293.667C344.278 293.722 344.222 294.778 344.667 294.333C344.722 294.278 344.778 293.222 344.333 293.667z"
      />
      <path
        fill="url(#img1)"
        d="M13 303L13 328C15.9244 321.095 15.9752 309.897 13 303M346 303L346 328C348.413 322.25 348.413 308.75 346 303z"
      />
      <path
        fill="url(#img1)"
        d="M24.3333 306.667C24.2778 306.722 24.2222 307.778 24.6667 307.333C24.7222 307.278 24.7778 306.222 24.3333 306.667M335.333 306.667C335.278 306.722 335.222 307.778 335.667 307.333C335.722 307.278 335.778 306.222 335.333 306.667z"
      />
      <path
        fill="url(#img1)"
        d="M19 309L19 312C19.6961 310.446 19.6961 310.554 19 309M340 309L340 312C340.696 310.446 340.696 310.554 340 309z"
      />
      <path
        fill="url(#img1)"
        d="M19 312L19 320C20.1614 317.23 20.1614 314.77 19 312M340 312L340 320C341.161 317.23 341.161 314.77 340 312z"
      />
      <path
        fill="url(#img1)"
        d="M19 320L19 323C19.6961 321.446 19.6961 321.554 19 320M340 320L340 323C340.696 321.446 340.696 321.554 340 320M24 324L24 327C24.6961 325.446 24.6961 325.554 24 324M335 324L335 327C335.696 325.446 335.696 325.554 335 324z"
      />
      <path
        fill="url(#img1)"
        d="M18 326L18 330C18.7102 328.24 18.7102 327.759 18 326M341 326L341 330C341.71 328.24 341.71 327.759 341 326z"
      />
      <path
        fill="url(#img1)"
        d="M18.3333 330.667C18.2778 330.722 18.2223 331.778 18.6667 331.333C18.7222 331.278 18.7778 330.222 18.3333 330.667M341.333 330.667C341.278 330.722 341.222 331.778 341.667 331.333C341.722 331.278 341.778 330.222 341.333 330.667z"
      />
      <path
        fill="url(#img1)"
        d="M17 333L17 337C17.7102 335.24 17.7102 334.76 17 333M342 333L342 337C342.71 335.24 342.71 334.76 342 333z"
      />
      <path
        fill="url(#img1)"
        d="M16.3333 339.667C16.2778 339.722 16.2222 340.778 16.6667 340.333C16.7222 340.278 16.7778 339.222 16.3333 339.667M343.333 339.667C343.278 339.722 343.222 340.778 343.667 340.333C343.722 340.278 343.778 339.222 343.333 339.667M15 343L16 344L15 343M344 343L345 344L344 343z"
      />
      <path
        fill="url(#img1)"
        d="M13.3333 421.667C13.2778 421.722 13.2222 422.778 13.6667 422.333C13.7222 422.278 13.7778 421.222 13.3333 421.667M346.333 421.667C346.278 421.722 346.222 422.778 346.667 422.333C346.722 422.278 346.778 421.222 346.333 421.667z"
      />
      <path
        fill="url(#img1)"
        d="M15.3333 429.667C15.2778 429.722 15.2222 430.778 15.6667 430.333C15.7222 430.278 15.7778 429.222 15.3333 429.667M344.333 429.667C344.278 429.722 344.222 430.778 344.667 430.333C344.722 430.278 344.778 429.222 344.333 429.667z"
      />
      <path
        fill="url(#img1)"
        d="M13 446L13 474C14.4549 470.533 13.9236 466.728 14.0147 463C14.1565 457.194 15.3862 451.532 13 446z"
      />
      <path
        fill="url(#img1)"
        d="M14 457L14 470C15.5909 466.209 15.5909 460.791 14 457z"
      />
      <path
        fill="url(#img1)"
        d="M20 459C20 463.716 20.1614 468.371 19.1119 473C18.3253 476.469 16.105 480.453 16.1821 484C16.2583 487.507 18.7372 491.73 20 495C28.6081 487.052 25.6712 468.012 20 459z"
      />
      <path
        fill="url(#img1)"
        d="M19 464L19 472C20.1614 469.23 20.1614 466.77 19 464z"
      />
      <path
        fill="url(#img1)"
        d="M52 472C54.8897 473.213 57.8741 472.998 61 473C58.1103 471.787 55.1259 472.002 52 472z"
      />
      <path
        fill="url(#img1)"
        d="M29.3333 473.667C29.2778 473.722 29.2222 474.778 29.6667 474.333C29.7222 474.278 29.7778 473.222 29.3333 473.667z"
      />
      <path
        fill="url(#img1)"
        d="M41 478C42.4785 478.986 42.2032 479 44 479C44.9857 477.521 45 477.797 45 476L47 476C47.7084 478.454 48.0381 480.45 48 483C54.4294 482.036 61.9017 478.978 65 473C57.3752 473 45.7182 470.665 41 478M70 490C72.2235 483.523 78.9716 480.637 82.8171 488.043C84.3072 490.913 83.5483 494 83 497C90.266 494.182 97.3836 490.763 105 489C98.4793 485.456 90.7459 483.996 84 480.742C80.8202 479.207 76.7161 476.156 73.0154 476.531C69.0734 476.93 66.5992 481.415 66.2577 485C65.8458 489.325 73.5922 499.271 76.8634 492.6C78.8842 488.478 71.7158 489.701 70 490M255 488C261.42 492.04 269.893 494.244 277 497C276.519 494.37 275.813 491.632 276.756 489.015C278.225 484.939 281.685 483.618 281 479C272.183 481.539 264.199 486.641 255 488z"
      />
      <path
        fill="url(#img1)"
        d="M75.6667 482.333C75.2222 482.778 76.2778 482.722 76.3333 482.667C76.7778 482.222 75.7222 482.278 75.6667 482.333z"
      />
      <path
        fill="url(#img1)"
        d="M124.667 482.333C124.222 482.778 125.278 482.722 125.333 482.667C125.778 482.222 124.722 482.278 124.667 482.333z"
      />
      <path
        fill="url(#img1)"
        d="M234.667 482.333C234.222 482.778 235.278 482.722 235.333 482.667C235.778 482.222 234.722 482.278 234.667 482.333z"
      />
      <path
        fill="url(#img1)"
        d="M47.6667 483.333C47.2222 483.778 48.2778 483.722 48.3333 483.667C48.7778 483.222 47.7222 483.278 47.6667 483.333z"
      />
      <path
        fill="url(#img1)"
        d="M59 485C54.8878 487.34 50.6761 489.195 46 490C51.0658 493.79 58.9107 496.259 65 498C62.4137 493.699 61.0192 489.457 59 485M179 486C176.3 491.19 171.655 493.69 168 498C172.203 497.187 175.91 493.206 180 492.996C184.029 492.789 187.919 497.179 192 498C188.367 493.716 183.393 489.539 179 486z"
      />
      <path
        fill="url(#img1)"
        d="M135 489L136 490L135 489M224 489L225 490L224 489z"
      />
      <path
        fill="url(#img1)"
        d="M290 494C289.314 493.102 288.67 491.858 287.684 491.177C283.85 488.53 280.852 492.32 284.978 494.103C286.615 494.81 288.352 494.314 290 494z"
      />
      <path
        fill="url(#img1)"
        d="M137 490C138.248 490.685 138.548 490.749 140 491C138.752 490.315 138.452 490.251 137 490M220 490C221.248 490.685 221.548 490.749 223 491C221.752 490.315 221.452 490.251 220 490z"
      />
      <path
        fill="url(#img1)"
        d="M32.6667 493.333C32.2222 493.778 33.2778 493.722 33.3333 493.667C33.7778 493.222 32.7222 493.278 32.6667 493.333z"
      />
      <path
        fill="url(#img1)"
        d="M94 498C98.4687 499.875 104.191 499 109 499L138 499C126.373 487.352 107.474 494.883 94 498M222 498C226.469 499.875 232.191 499 237 499L266 499C253.539 491.159 234.598 490.838 222 498M26 498C34.3558 499.056 42.5787 499 51 499C45.4266 495.493 29.2869 489.823 26 498M146 497C148.308 498.759 150.092 498.917 153 499C150.686 497.409 148.81 497.142 146 497M207 498C209.587 499.065 211.321 498.781 214 498C211.477 497.01 209.642 497.383 207 498z"
      />
      <path
        fill="url(#img1)"
        d="M65 498L66 499L65 498M294 498L295 499L294 498z"
      />
    </svg>
  );
}
